import { render, staticRenderFns } from "./CostumeOrder.vue?vue&type=template&id=2ddc3be6&scoped=true"
import script from "./CostumeOrder.vue?vue&type=script&lang=js"
export * from "./CostumeOrder.vue?vue&type=script&lang=js"
import style0 from "./CostumeOrder.vue?vue&type=style&index=0&id=2ddc3be6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddc3be6",
  null
  
)

export default component.exports